import { env } from "./env";

export const features = {
  OAUTH_LOGIN: env.VITE_ENABLE_OAUTH,
  DEVTOOLS: env.VITE_ENABLE_DEVTOOLS && env.MODE === "development",
  DARK_MODE: true,
} as const;

export type FeatureFlag = keyof typeof features;

export const isFeatureEnabled = (flag: FeatureFlag): boolean => {
  return features[flag];
};
